var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.enlight)?_c('v-badge',{staticClass:"menu-item-icon",attrs:{"dot":"","bordered":"","overlap":"","color":"warning"}},[_c(_setup.MenuItemIconInner,{attrs:{"name":_vm.name}})],1):_c(_setup.MenuItemIconInner,{attrs:{"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }